import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Icon from "./Icons";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [resetUrl, setResetUrl] = useState("");

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");
    setResetUrl("");

    try {
      const { data } = await axios.post("/api/user/forgot-password", { email });
      setMessage(data.message);
      setResetUrl(data.resetUrl || "");
    } catch (requestError) {
      setError(requestError.response?.data?.message || "We could not start password recovery. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-5 py-14">
      <div className="w-full max-w-md">
        <Link to="/login" className="mb-9 inline-flex items-center gap-2 text-sm text-cream-muted no-underline transition-colors hover:text-cream">
          <Icon name="arrow" className="rotate-180" size={15} /> Back to sign in
        </Link>

        <p className="sc-kicker mb-3">Account recovery</p>
        <h1 className="font-serif text-4xl font-semibold tracking-[-0.03em] text-cream">Find your way back.</h1>
        <p className="mt-2 text-sm leading-relaxed text-cream-muted">Enter the email attached to your library and we’ll send you a secure reset link.</p>

        <div className="sc-panel mt-8 p-6 sm:p-7">
          {error && <div className="mb-5 rounded-xl border border-crimson/30 bg-crimson/10 px-4 py-3 text-sm text-crimson-light">{error}</div>}

          {message ? (
            <div className="text-center">
              <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/10 text-gold"><Icon name="arrow" size={20} /></span>
              <h2 className="font-serif text-2xl text-cream">Check your inbox</h2>
              <p className="mt-2 text-sm leading-relaxed text-cream-muted">{message}</p>
              {resetUrl && (
                <a href={resetUrl} className="sc-btn-gold mt-6 w-full no-underline">Continue to reset <Icon name="arrow" size={15} /></a>
              )}
              <button onClick={() => setMessage("")} className="mt-4 text-xs text-cream-muted transition-colors hover:text-cream">Try another email</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="recovery-email">Email address</label>
                <input id="recovery-email" type="email" value={email} onChange={event => setEmail(event.target.value)} placeholder="you@example.com" className="sc-input" required autoFocus />
              </div>
              <button type="submit" disabled={loading} className="sc-btn-gold w-full py-3 disabled:opacity-50">
                {loading ? "Sending reset link…" : <><span>Send reset link</span><Icon name="arrow" size={15} /></>}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
